import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import moment from "moment";

import { DatePickerContext } from "./DatePickerContext";
import { DatePickerRangeInputProps } from "./datePicker.type";

import Box from "../Box/Box";
import Input from "../Input/Input";

const DatePickerInputContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  gap: 20px;
`;

const DatePickerInputWrapper = styled(Box)`
  flex: 1;
`;

const DatePickerRangeInput = ({
  dateFormat,
  rangeStart,
  rangeEnd,
}: DatePickerRangeInputProps) => {
  const {
    selectedRangeStart,
    selectedRangeEnd,
    showCalendar,
    setSelectedRange,
    setShowCalendar,
    resetSelectedRange,
  } = useContext(DatePickerContext);

  const [startInputValue, setStartInputValue] = useState<string>("");
  const [endInputValue, setEndInputValue] = useState<string>("");

  const [startInputFocused, setStartInputFocused] = useState<boolean>(false);
  const [endInputFocused, setEndInputFocused] = useState<boolean>(false);

  useEffect(() => {
    if (
      rangeStart &&
      moment(rangeStart).isValid() &&
      rangeEnd &&
      moment(rangeEnd).isValid()
    ) {
      setSelectedRange(
        moment(rangeStart).valueOf(),
        moment(rangeEnd).valueOf()
      );
    } else {
      resetSelectedRange();
    }
  }, [rangeStart, rangeEnd]);

  useEffect(() => {
    const selectedRangeStartDate = selectedRangeStart
      ? moment(selectedRangeStart).format(dateFormat)
      : "";
    const selectedRangeEndDate = selectedRangeEnd
      ? moment(selectedRangeEnd).format(dateFormat)
      : "";
    setStartInputValue(selectedRangeStartDate);
    setEndInputValue(selectedRangeEndDate);
  }, [selectedRangeStart, selectedRangeEnd, dateFormat]);

  useEffect(() => {
    if (showCalendar) {
      if (selectedRangeStart) {
        setStartInputFocused(false);
        setEndInputFocused(true);
      } else {
        setStartInputFocused(true);
        setEndInputFocused(false);
      }
    } else {
      setStartInputFocused(false);
      setEndInputFocused(false);
    }
  }, [showCalendar, selectedRangeStart]);

  return (
    <DatePickerInputContainer aria-label="datepicker input">
      <DatePickerInputWrapper>
        <Input
          icon="calendar-alt"
          iconWeight="regular"
          value={startInputValue}
          onChange={() => {}}
          placeholder="From"
          onFocus={() => setShowCalendar(true)}
          focused={startInputFocused}
        />
      </DatePickerInputWrapper>
      <DatePickerInputWrapper>
        <Input
          icon="calendar-alt"
          iconWeight="regular"
          value={endInputValue}
          onChange={() => {}}
          placeholder="To"
          onFocus={() => setShowCalendar(true)}
          focused={endInputFocused}
        />
      </DatePickerInputWrapper>
    </DatePickerInputContainer>
  );
};

export default DatePickerRangeInput;
